import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { submit } from 'redux-form';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';

import AddApplicantForm from './AddApplicantForm';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from 'material-ui/FlatButton';
import { getApplication } from 'actions/landlordApplicationsActions';
import { openEditLease } from 'actions/LeaseDetailsActions';

import { getLeadByEmail } from 'actions/landlordLeadsActions';

import { getTenants } from 'actions/landlordTenantsActions';

import { deepDiver } from 'helpers/utilities';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';

import { DuplicateLead } from 'components/shared/DuplicateLead/DuplicateLead';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import { getTranslatedString } from 'helpers/i18n';
import { tenantResidentVerbiage } from 'helpers/StringHelper';

const AppDialogContent = styled.div`
  padding: 0 25px;
`;

let ApplicantDialog = withMobileDialog()(
  connect(
    state => ({
      showTenantAdditionalOccupant: state.userTypes.showTenantAdditionalOccupant,
      showTenantPetDetails: state.userTypes.showTenantPetDetails,
      collectLeadSinNumberDuringApplication:
        state.companyDetails.companyPreferences.collect_lead_sin_number_during_application,
      propertyTypes: state.userTypes.propertyTypes,
      minimumApplicantAge: state.companyDetails.companyPreferences.minimum_applicant_age,
    }),

    {
      submit,
      getApplication,
      openEditLease,
      getLeadByEmail,
      getTenants,
    }
  )(
    class ApplicantDialog extends Component {
      state = {
        existingTenant: null,
        confirmationDialogOpen: false,
        newTenant: null,
        confirmedAction: false,
        disabledSubmit: false,
      };

      submitForm = async formData => {
        this.setState({ disabledSubmit: true });

        if (!this.state.confirmedAction) {
          const response = await this.props.getLeadByEmail(formData.email, {
            exclude_id: this.props.applicant.lead_id,
          });
          if (deepDiver(response, 'value.lead')) {
            this.setState({
              existingTenant: response.value.lead,
              newTenant: formData,
              disabledSubmit: false,
            });
            return;
          } else {
            this.setState({ existingTenant: null, newTenant: null });
          }
        }

        let response;
        let confirmedSameResident = false;
        if (this.state.confirmedAction) {
          confirmedSameResident = true;
        }

        if (this.props.createOrUpdateTenant) {
          let leaseId = null;
          if (this.props.application) {
            leaseId =
              deepDiver(this.props.applicant, 'lease.id') || this.props.application.lease_id;
          } else {
            leaseId =
              deepDiver(this.props.applicant, 'lease.id') ||
              deepDiver(this.props.applicant, 'leases.0.id');
          }
          response = await this.props.createOrUpdateTenant(leaseId, this.props.applicant.id, {
            ...formData,
            confirmed_same_resident: confirmedSameResident,
          });
        } else if (this.props.createOrUpdateApplicant) {
          response = await this.props.createOrUpdateApplicant(
            this.props.application.id,
            this.props.applicant.id,
            { ...formData, confirmed_same_resident: confirmedSameResident }
          );
        }

        if (response) {
          this.props.getTenants();
          this.props.toggleApplicantDialog();
          if (this.props.callback) {
            await this.props.callback();
          }
          this.setState({ disabledSubmit: false, confirmedAction: false });
        }
      };

      toggleConfirmationDialog = () => {
        if (this.state.confirmationDialogOpen) {
          this.setState({ disabledSubmit: false, existingTenant: null, newTenant: null });
        }
        this.setState(prevState => ({
          confirmationDialogOpen: !prevState.confirmationDialogOpen,
        }));
      };

      render() {
        const {
          fullScreen,
          applicantType,
          hideSalary,
          overrideHideApplicationDetails,
          translate,
        } = this.props;
        const headerVerbiage =
          applicantType === 'tenant' ? <TenantResidentVerbiageHelper capitalize /> : 'Applicant';
        return (
          <Fragment>
            <Dialog
              disableBackdropClick
              fullScreen={fullScreen}
              open={this.props.applicantDialogOpen}
              onClose={() => {
                this.props.toggleApplicantDialog();
                this.setState({ existingTenant: null, newTenant: null, disableSubmit: false });
              }}
              aria-labelledby="add-new-applicant"
              classes={{
                paper: 'form-dialog',
              }}
            >
              <DialogTitle id="add-new-applicant">
                <div>
                  <h3 style={{ textAlign: 'center', margin: 0 }}>{headerVerbiage}</h3>
                  {this._renderHeaderFooter(applicantType)}
                </div>
              </DialogTitle>
              <AppDialogContent>
                <AddApplicantForm
                  minimumApplicantAge={this.props.minimumApplicantAge}
                  onSubmit={this.submitForm}
                  initialValues={this.props.applicant}
                  applicantType={applicantType}
                  hideSalary={hideSalary}
                  hideApplicationDetails={!deepDiver(this.props.applicant, 'applied')}
                  overrideHideApplicationDetails={overrideHideApplicationDetails}
                  showTenantAdditionalOccupant={this.props.showTenantAdditionalOccupant}
                  showTenantPetDetails={this.props.showTenantPetDetails}
                  collectLeadSinNumberDuringApplication={
                    this.props.collectLeadSinNumberDuringApplication
                  }
                  existingTenant={this.state.existingTenant}
                  toggleConfirmationDialog={this.toggleConfirmationDialog}
                />
              </AppDialogContent>
              <DialogActions style={{ display: 'block' }}>
                <FlatButton
                  onClick={() => {
                    this.props.toggleApplicantDialog();
                    this.setState({ existingTenant: null, newTenant: null });
                  }}
                  id="close-button"
                  style={{ color: AccentColor() }}
                  disabled={this.state.disabledSubmit}
                >
                  {translate('landlordPortal.applicantDialog.cancel')}
                </FlatButton>
                <FlatButton
                  variant="raised"
                  onClick={() => this.props.submit('add_applicant_form')}
                  disabled={this.state.disabledSubmit}
                  id="submit-button"
                  style={{
                    color: 'white',
                    backgroundColor: this.state.disabledSubmit ? colors.LIGHT_GRAY : AccentColor(),
                  }}
                >
                  {translate('landlordPortal.applicantDialog.save')}
                </FlatButton>
              </DialogActions>
            </Dialog>

            <ConfirmationDialog
              showDialog={this.state.confirmationDialogOpen}
              hideDialog={this.toggleConfirmationDialog}
              userConfirmVerbiage={getTranslatedString('landlordPortal.confirmationText.confirm')}
              userConfirmAction={() => {
                this.toggleConfirmationDialog();
                this.setState({ confirmedAction: true }, () =>
                  this.props.submit('add_applicant_form')
                );
              }}
              dialogTitle={
                <span>
                  {getTranslatedString('landlordPortal.confirmationText.saveResident', {
                    tenantResident: tenantResidentVerbiage(this.props.propertyTypes),
                  })}
                </span>
              }
              dialogBodyVerbiage={this._renderExistingTenant()}
              confirmationText={getTranslatedString('landlordPortal.confirmationText.confirm')}
            />
          </Fragment>
        );
      }

      _renderHeaderFooter = headerVerbiage => {
        if (headerVerbiage === 'tenant') return null;

        return (
          <p
            style={{
              textAlign: 'justify',
              marginTop: '10px',
              fontSize: '14px',
              marginBottom: '-10px',
            }}
          >
            <i className="em em-warning" />
            <b style={{ color: '#ff3434', fontFamily: 'Circular-Bold' }}>
              {this.props.translate('landlordPortal.applicantDialog.important')}
            </b>
            <i className="em em-warning" />{' '}
            {this.props.translate('landlordPortal.applicantDialog.ifTheLease')}
          </p>
        );
      };

      _renderExistingTenant = () => {
        if (!this.props.applicant) return;
        const lease = deepDiver(this.props.applicant, 'leases.0');
        return (
          <DuplicateLead
            existingTenant={this.state.existingTenant}
            newTenant={this.state.newTenant}
            newLease={lease}
          />
        );
      };
    }
  )
);

export default localize()(ApplicantDialog);
